import { TooltipProps, TooltipTrigger } from "react-aria-components";

import { Text } from "../../foundations/typography/Text";

import { _Tooltip } from "./assets/_Tooltip";

interface MyPopoverProps extends Omit<TooltipProps, "children"> {
  children: React.ReactNode;
  description?: string;
  testID: string;
  isOpen?: boolean;
}

export function Tooltip(props: MyPopoverProps) {
  const { children, description, isOpen, ...rest } = props;
  return (
    <TooltipTrigger {...{ isOpen }}>
      {children}
      <_Tooltip {...rest}>
        <Text as="div" style="global/info-label" color="text-inverse">
          {description}
        </Text>
      </_Tooltip>
    </TooltipTrigger>
  );
}
